import { render, staticRenderFns } from "./IsKycOk.vue?vue&type=template&id=78a7dae4&scoped=true"
import script from "./IsKycOk.vue?vue&type=script&lang=js"
export * from "./IsKycOk.vue?vue&type=script&lang=js"
import style0 from "./IsKycOk.vue?vue&type=style&index=0&id=78a7dae4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a7dae4",
  null
  
)

export default component.exports